(() => {
    function insta() { // create insta function
      const instafeedContainer = document.querySelectorAll('.instafeed-container, .instafeed-new-layout-item');
      let count = 0;
      if(instafeedContainer.length > 0) { // check if the insta container is available
        instafeedContainer.forEach((item, index) => {
          count = index + 1;
          const instaHashtag = document.querySelector(`.instafeed-hashtag-${count}`);
          item.insertAdjacentHTML('beforeend', instaHashtag.innerHTML);
        })
      } else { // if not, then run again the insta function
        setTimeout(() => {
          insta();
        }, 500)
      }
    }
    insta(); // call the insta function
  })();